import { PublicClientApplication } from "@azure/msal-browser";
import { MSAL_CONFIG } from "../config";

/**
 * Shared MSAL instance — singleton.
 * Import this everywhere instead of creating new PublicClientApplication instances.
 */
export const msalInstance = new PublicClientApplication(MSAL_CONFIG);

/**
 * Call once at app startup (before rendering).
 * Resolves redirects and sets the active account if one exists.
 */
export const initializeMsalInstance = async (): Promise<void> => {
    await msalInstance.initialize();

    // Handle redirect promise (for redirect-based login flows)
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
        msalInstance.setActiveAccount(response.account);
    }

    // If no active account, try to set one from cache
    if (!msalInstance.getActiveAccount()) {
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }
    }
};

/**
 * @deprecated Use the named export `msalInstance` directly instead.
 */
export const getMsalInstance = async () => {
    return msalInstance;
};